import styled from 'styled-components';
import {
  MARGIN,
  REBRAND_COLOR,
  BREAKPOINT,
  PADDING
} from '@latitude/core/utils/constants';
import { Link } from '@latitude/link';
import Section from '@latitude/section-rebrand';

export const Wrapper = styled.div`
  background-color: ${REBRAND_COLOR.STONE};
`;

export const StyledAdditionalCards = styled(Section)`
  background-color: ${REBRAND_COLOR.STONE};
  width: 100%;
  margin: 0 auto;
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};
  @media (min-width: ${BREAKPOINT.LG}) {
    padding-top: ${PADDING.P64};
    padding-bottom: ${PADDING.P64};
  }
  > :first-child {
    text-align: center;
  }
  @media (min-width:1600px) {
    padding-left: ${PADDING.P64};
    padding-right: ${PADDING.P64};
  }
`;

export const StyledItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: ${MARGIN.M32};
  @media (min-width: ${BREAKPOINT.LG}) {
    flex-wrap: nowrap;
  }
`;

export const StyledItem = styled(Link)`
  width: 120px;
  margin-right: calc(50% - 120px);
  margin-bottom: ${MARGIN.M40};
  cursor: pointer;
  transition: all 100ms ease-in-out;

  &:hover {
    transform: scale(1.03);
    transition: all 100ms ease-in-out;
  }

  @media (min-width: ${BREAKPOINT.LG}) {
    margin-right: 0;
  }
`;

export const StyledItemImage = styled.img`
  width: 100%;
  margin-bottom: ${MARGIN.M8};
`;
